import React from 'react';
import ReactDOM from 'react-dom';
import AgendaForm from './AgendaForm';
import AgendaNavBar from './AgendaNavBar';
import AgendaFooter from './AgendaFooter';

import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';

ReactDOM.render(
	<AgendaNavBar />,
	document.getElementById('navbar')
);

ReactDOM.render(
	<AgendaForm />,
	document.getElementById('root')
);

ReactDOM.render(
	<AgendaFooter />,
	document.getElementById('footer')
);




// WEBPACK FOOTER //
// ./src/index.js